import { combineEpics, Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import {
  switchMap,
  map,
  startWith,
  catchError,
  filter,
} from 'rxjs/operators';
import { isOfType } from 'typesafe-actions';

import {
  NoteflowTaskActions,
  NoteflowTaskActionTypes,
  loadedNoteflowTasks,
  loadingNoteflowTasks,
  loadingNoteflowTasksFailed,
} from '../actions/noteflowTaskActions';
import { IState } from '../reducers';
import {
  getNoteflowTasks,
} from '../../services/noteflowTaskApi';

const getNoteflowTasksEpic: Epic<NoteflowTaskActions, NoteflowTaskActions, IState, any> = (
  action$: any,
  state$: any,
  { dispatch }: any
) =>
  action$.pipe(
    filter(isOfType(NoteflowTaskActionTypes.LOAD_NOTEFLOW_TASKS)),
    switchMap((action: any) =>
      from(getNoteflowTasks(action.payload)).pipe(
        map((response: any) => {
          return loadedNoteflowTasks(response.result, action.payload);
        }),
        startWith(loadingNoteflowTasks()),
        catchError((err: any) => {
          const message = err.response?.data?.message || "";

          console.log('[error] message: ', message);

          return of(loadingNoteflowTasksFailed());
        })
      )
    )
  );

export default combineEpics(
  getNoteflowTasksEpic
);
